export const dreamTeamsRoutePath = 'teamDiscovery';
export const dreamTeamsSelfServeRoutePath = 'selfServe';
export const sharedSummaryRoutePath = 'sharedSummary';
export const hubAndSpokeRoutePath = 'hub';
export const hire2RoutePath = 'hire';
export const design2Home = 'design/teamDiscovery/home';
export const design2Team = 'design/team/';
export const designExplainerPath = '/unlock/design';
export const hireExplainerPath = '/unlock/hire';
export const inspireExplainerPath = '/unlock/inspire';
export const Inspire2Link = 'inspire/client';
export const inspire2OnboardingLink = 'inspire/client/onboarding';
export const diagnoseExplainerPath = '/unlock/diagnose';
export const diagnose2RoutePath = 'diagnose';
export const inspireRoutePath = 'inspire/individuals'; // Temp RoutePath to InspireV1 until Inspirev2 available for clients
export const performExplainerPath = '/unlock/perform';
export const performNoAccessPath = '/no-access/perform';
export const adminRoutePath = 'admin';
export const platformRoutePath = 'pi';
export const performLoginPath = '/token_auth/pi_auth0_login';
export const groupAnalyticsPath = 'groupanalytics';
export const sellerExperiencePath = 'seller-experience';
